// extracted by mini-css-extract-plugin
export default {"header":"HeaderText_header__lDCgj"};